import { createContext, useContext } from 'react'
import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'

export const DashboardAndModalFilterContext = createContext();


export function DashboardAndModalFilterProvider({ children }){
    const { 
            listBusinessToFilter, 
    } = useAdministrativeContext()



    return(
        <DashboardAndModalFilterContext.Provider 
            value={ {       
                listBusinessToFilter,
            } }
        >
            { children }
        </DashboardAndModalFilterContext.Provider>
    )
}



export function useDashboardAndModalFilter() {
   const context = useContext(DashboardAndModalFilterContext)

   if(!context) {
    throw new Error('useDashboardAndModalFilter must be used within an Provider');
  } 

   return context
}
